<template>
  <div class="index">
<!--    <div class="btn" @click="btnClick()">-->
<!--      全球数据卡-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: 'index',
    data () {
      return {

      }
    },

    mounted(){
      // window.location = window.location.origin + '/cmlink/#/'
    },

    created(){
      window.location = window.location.origin + '/piao/#/'
    },

    methods:{
      btnClick(){
        // this.$router.push({path:'/login'})
        window.location = window.location.origin + '/piao/#/'
      },
    }
  }
</script>


<style scoped>
  .btn{
    margin:  1rem auto;
    display: block;
    width: 50%;
    font-size: 0.5rem;
    border: 1px solid gray;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue